import React, { useEffect, useState } from 'react';
import Loader from './Loader'; // NOTE the name === measures is a hack because of https://github.com/highcharts/highcharts/issues/6427

var _ref = /*#__PURE__*/React.createElement(Loader, {
  key: "root"
});

const DelayedLoader = ({
  smallWidget,
  name
}) => {
  const [showLoader, setShowLoader] = useState(false);
  useEffect(() => {
    const timer = smallWidget === false && name !== 'measures' ? setTimeout(() => setShowLoader(true), 100) : setTimeout(() => setShowLoader(true), 1000);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => setShowLoader(false), 10000);
    return () => clearTimeout(timer);
  }, []);
  return showLoader ? _ref : null;
};

export default DelayedLoader;